import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Button, Input, Form, Select, InputNumber, Modal, message } from 'antd';
import { EditFilled, DeleteFilled, CopyOutlined } from '@ant-design/icons';
import {
  PhoneOutlined,

  PauseOutlined,
  SwapOutlined,
  CaretRightOutlined,
  AudioMutedOutlined,
  AudioOutlined,
} from "@ant-design/icons";

import { Typography, Space, Alert, Result } from 'antd';
import { ReloadOutlined, CheckCircleFilled, WarningFilled } from '@ant-design/icons';

import useAxios from './../../../CustomHooks/useAxios';
import DebounceSelect from './../../DebounceSelect'
const { Option } = Select;
const { TextArea } = Input;
const { Text, Title } = Typography;
export default function Add({ setRefressSearch, setVisibleAdd }) {
  const hideItem = useSelector((state) => state.loginReducer.hideItem);
  const user = useSelector((state) => state.loginReducer.user);
  const { axiosi } = useAxios();


  const [companyid, setCompanyid] = React.useState({ value: user.agents[0].company_id, label: user.agents[0].gmcomname });

  const [nextMainDialPlainSelectedid, setNextMainDialPlainSelectedid] = useState('');
  const [nextMainDialPlanData, setNextMainDialPlanData] = useState(null);

  const [telout, setTelout] = useState("");
  const [telsoutData, setTelsoutData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [newToken, setNewToken] = useState("");

  async function fetchUserList(company_name) {
    console.log('fetching user', company_name);
    const body = await axiosi.get('companies', { params: { company_name, pageSize: 100 } });
    if (body?.data?.rows) {
      return body?.data?.rows.map((user) => ({
        label: user.company_name,
        value: user.id,
        //  value:{id: user.id,company_code:user.company_code},
        company_code: user.company_code,
      }));
    }
    else {
      const a = [{ label: "---no data---", value: "" }]
      return a.map(i => (i))
    }

  }



  const onFinishAdd = async (values) => {
    // setNewToken("hello");
    // setIsModalOpen(true);
    // return;
    let adddata = {
      ...values,
      company_id: companyid.value,
      tel_id: telout, main_dialplan_id: nextMainDialPlainSelectedid
    };

    console.log("[onFinishAdd]:adddata=", adddata);

    // return;
    try {
      const kq = await axiosi.post("autocall_settings", adddata);
      console.log("[onFinishAdd]:kq=", kq)
      setVisibleAdd(false);
      setRefressSearch(pre => !pre);
      setNewToken(kq.data.token);
      setIsModalOpen(true);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log("error.response.data:", error.response.data);
        console.log("error.response.status:", error.response.status);
        console.log("error.response.headers:", error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log("error.request :", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error error.message', error.message);
      }
      console.log("error.config:", error.config);
    }
  }
  const onFinishFailedAdd = (error) => {
    console.log("[onFinishFailedAdd]:error=", error);
  }


  const handleOnChangeCompanyName = async (value) => {
    setCompanyid(value);

  }


  const handleOnChangeNextMainDialPlan = (value) => {
    setNextMainDialPlainSelectedid(value);
    console.log("[handleOnChangeNextMainDialPlan]:value=", value)
  }

  function onSearch(val) {
    console.log('search:', val);
  }
  const handleOnChangeTelsout = async (value) => {
    setTelout(value);
    console.log(value);
  }
  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    message.info({
      content: "copied !",
      className: "custom-class",
      style: {
        position: "absolute",
        top: "-15px",
        right: "1px",
      },
    });
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    const getNextMainDialplan = async () => {
      try {
        if (companyid) {
          const kq = await axiosi.get('ivrplanmain', { params: { company_id: companyid.value, pageSize: 1000 } });
          console.log("[useEffect-getNextMainDialplan]:kq=", kq)
          setNextMainDialPlanData(kq.data.rows);
        } else {
          setNextMainDialPlanData(null);
        }
      }
      catch (err) {
        console.log("[useEffect-getNextMainDialplan]:err=", err);
      }

    }
    getNextMainDialplan();
  }, [companyid.value])
  useEffect(() => {
    const getTeloutsid = async () => {
      const kq = await axiosi.get('tels', { params: { companyid: companyid.value, pageSize: 1000 } });
      console.log("[useEffect-handleOnChangeCompanyName]:kq_get_tels=", kq);
      console.log("[useEffect-handleOnChangeCompanyName]:selectedvalue=", companyid.value);
      setTelsoutData(kq.data);
      setTelout("");
    };
    getTeloutsid();
  }, [companyid.value])
  return (<>


    {/* {console.log("[return]:ivrVisible=",ivrVisible)} */}
    <Modal
      title={
        <Space>

          <span>&emsp;<b>New Token</b></span>
        </Space>
      }
      open={isModalOpen}
      onCancel={handleCancel}
      centered
      footer={[
        <Button key="close" onClick={handleCancel}>
          Close
        </Button>
      ]}
    >
      <div style={{ padding: '10px 0' }}>
        {newToken === "" ? (
          /* Trạng thái 1: Xác nhận trước khi tạo mới */
          <></>

        ) : (
          /* Trạng thái 2: Hiển thị Token mới */
          <div style={{ textAlign: 'center' }}>
            <Result
              status="success"
              title="Autocall Setting is added successfully!"
            />
            <Alert
              message="New Token Key"
              description={
                <div style={{ marginTop: 5 }}>
                  <Text
                    code
                    // Quan trọng: copyable vẫn giữ newToken gốc để người dùng dán ra là full mã
                    copyable={{ text: newToken }}
                    style={{
                      fontSize: '16px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '12px',
                      background: '#f5f5f5',
                      borderRadius: '4px',
                      border: '1px dashed #d9d9d9'
                    }}
                  >
                    {/* Chỉ hiển thị 8 ký tự đầu ... và 8 ký tự cuối */}
                    {newToken.length > 16
                      ? `${newToken.substring(0, 8)} •••••••••••• ${newToken.slice(-8)}`
                      : newToken}
                  </Text>
                </div>
              }
              type="info"
              showIcon
            />
            <p style={{ color: 'red', marginTop: "10px" }}>Please copy and save it, it will not show again!</p>
            <Button
              type="primary"
              icon={<CopyOutlined />}
              style={{ marginTop: 20 }}
              onClick={() => handleCopy(newToken)}
            >
              Copy to Clipboard
            </Button>
          </div>
        )}
      </div>
    </Modal>
    <Form
      name="basic"
      labelCol={{ span: 9 }}
      wrapperCol={{ span: 15 }}
      initialValues={{
        ordnum: 0,
        numcurrentcall: 5,
        allownumcall: 2,
        minutebetweencall: 300,
        allowdaycall: 1,
        manualsurvey: 0

      }}
      onFinish={onFinishAdd}
      onFinishFailed={onFinishFailedAdd}
      autoComplete="off"
    >




      <Form.Item className={hideItem}
        label="Company Name"
        rules={[{ required: true, message: 'Please input a company_name!' }]}
      >
        <DebounceSelect
          showSearch={true}
          value={companyid}
          placeholder="Select users"
          fetchOptions={fetchUserList}
          onChange={handleOnChangeCompanyName}
          style={{ width: '100%', }}
        />
      </Form.Item>
      <Form.Item
        label="Name :"
        name="token_name"
        rules={[{ required: true, message: 'Please input a token name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="nextmaindialplanid :"
        // name="nextmaindialplanid"
        rules={[{ required: false, message: 'Please input an nextmaindialplanid!' }]}
      >

        <Select style={{ width: '100%' }} showSearch
          onChange={handleOnChangeNextMainDialPlan}
          //(value)=>setMenu_item_id(value)}
          // loading={menuItemDataLoading}
          value={nextMainDialPlainSelectedid}
          optionFilterProp="children"
          placeholder="Select a person"
          onSearch={onSearch}
          filterOption={(input, option) =>
            option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }

        >
          <Option value=""></Option>
          {nextMainDialPlanData && nextMainDialPlanData.map(item => (
            <Option key={item.id} value={item.id}>{item.name}</Option>
          ))}
        </Select>


      </Form.Item>

      <Form.Item
        label="pbxtel"
        rules={[{ required: false, message: 'Please input an pbxtel!' }]}
      >

        <Select style={{ width: '100%' }}
          onChange={handleOnChangeTelsout}
          value={telout}

        >
          <Option value=""></Option>
          {telsoutData?.rows && telsoutData.rows.map(item => (
            <Option key={item.id} value={item.id}>{item.telout}</Option>
          ))}
        </Select>



      </Form.Item>

      <Form.Item
        label="Allow IP :"
        name="allow_ips"
        rules={[{ required: false, message: 'Please input allowed IP list!' }]}
      >
        <TextArea rows={4} placeholder="1.1.1.1,2.2.2.2,3.3.3.3" />
      </Form.Item>
      <Form.Item
        label="Note :"
        name="note"
        rules={[{ required: false, message: 'Please input a note!' }]}
      >
        <TextArea rows={4} placeholder="Note"
        />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </Form>
  </>);
}
